var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBakery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A8254",
    d: "M13.174 0c-1.345 0-2.611.324-3.739.885C9.121.85 8.802.827 8.478.827 3.825.827.053 4.607.053 9.271c0 4.663 3.772 8.443 8.425 8.443 1.345 0 2.611-.323 3.74-.885.314.036.632.058.956.058 4.654 0 8.426-3.78 8.426-8.443C21.6 3.78 17.828 0 13.174 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C494",
    d: "M19.781 8.667c-.661 0-1.232.383-1.508.938-.275-.555-.846-.938-1.507-.938-.662 0-1.233.383-1.509.938-.275-.555-.847-.938-1.507-.938-.662 0-1.232.383-1.509.938-.276-.555-.847-.938-1.507-.938-.662 0-1.232.383-1.509.938-.276-.555-.847-.938-1.508-.938-.66 0-1.231.383-1.508.938-.276-.555-.846-.938-1.508-.938-.66 0-1.232.383-1.507.938-.277-.555-.847-.938-1.509-.938-.93 0-1.685.756-1.685 1.69L2.028 23.2H19.44l2.028-12.844c0-.934-.755-1.69-1.686-1.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E040",
    d: "M7.42 3.355c0 .429-.348.777-.776.777-.429 0-.776-.348-.776-.777 0-.43.347-.778.776-.778.428 0 .775.348.775.778M15.52 2.577c0 .43-.348.778-.776.778-.429 0-.776-.348-.776-.778 0-.429.347-.777.776-.777.428 0 .775.348.775.777M11.92 4.497c0 .43-.348.778-.776.778-.429 0-.776-.349-.776-.778 0-.43.347-.778.776-.778.428 0 .775.349.775.778"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBakery);
export default __webpack_public_path__ + "static/media/bakery.85084db6caf359a0ffd8834e2349a576.svg";
export { ForwardRef as ReactComponent };